import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// components
import LoadingScreen from '../components/loading-screen';
//
import Login from '../pages/auth/LoginPage';
import { useAuthContext } from './useAuthContext';
import {
  PATH_DASHBOARD,
  PATH_ADMIN_DASHBOARD,
  PATH_TRAINER_DASHBOARD,
  USER_ROLE,
} from '../routes/paths';

// ----------------------------------------------------------------------

/**
 * Auth Guard for Owner
 */

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuthContext();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    if (
      user?.role !== undefined &&
      user?.role !== null &&
      (user?.role === USER_ROLE.admin ||
        user?.role === USER_ROLE.salesAgent ||
        user?.role === USER_ROLE.financeAdmin)
    ) {
      return <Navigate to={PATH_ADMIN_DASHBOARD.general.app} />;
    }
    if (user?.role !== undefined && user?.role !== null && user?.role === USER_ROLE.owner) {
      return <Navigate to={PATH_DASHBOARD.root} />;
    }
    if (
      user?.role !== undefined &&
      user?.role !== null &&
      (user?.role === USER_ROLE.trainer ||
        user?.role === USER_ROLE.assistantTrainer ||
        user?.role === USER_ROLE.jockey)
    ) {
      return <Navigate to={PATH_TRAINER_DASHBOARD.app} />;
    }
  }

  return <> {children} </>;
}
